import type { Template } from "@/types";

export const LA_07_H3_V4: Template[] = [
    {
        id: "la-07-h3v4-01",
        name: "LA 01 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h3_v4_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 126, y: 41, width: 208, height: 139, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 41, width: 208, height: 139, rotation: 0, imageRotation: 0 },
            { id: "3", x: 126, y: 188, width: 423, height: 254, rotation: 0, imageRotation: 0 },
            { id: "4", x: 867, y: 41, width: 150, height: 197, rotation: 0, imageRotation: 0 },
            { id: "5", x: 867, y: 245, width: 150, height: 197, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1025, y: 41, width: 149, height: 197, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1025, y: 245, width: 149, height: 197, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-02",
        name: "LA 02 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h3_v4_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 79, y: 41, width: 198, height: 128, rotation: 0, imageRotation: 0 },
            { id: "2", x: 79, y: 177, width: 198, height: 128, rotation: 0, imageRotation: 0 },
            { id: "3", x: 79, y: 313, width: 198, height: 128, rotation: 0, imageRotation: 0 },         
            { id: "4", x: 285, y: 41, width: 304, height: 400, rotation: 0, imageRotation: 0 },
            { id: "5", x: 782, y: 41, width: 302, height: 400, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1091, y: 41, width: 146, height: 196, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1091, y: 245, width: 146, height: 196, rotation: 0, imageRotation: 0 },        
        ],
    },

    {
        id: "la-07-h3v4-03",
        name: "LA 03 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h3_v4_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 126, y: 40, width: 423, height: 257, rotation: 0, imageRotation: 0 },     
            { id: "2", x: 126, y: 305, width: 208, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 305, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 804, y: 40, width: 299, height: 404, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1111, y: 40, width: 113, height: 130, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1111, y: 178, width: 113, height: 129, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1111, y: 315, width: 113, height: 129, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-04",
        name: "LA 04 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h3_v4_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 47, y: 58, width: 181, height: 118, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 183, width: 181, height: 118, rotation: 0, imageRotation: 0 },
            { id: "3", x: 47, y: 308, width: 181, height: 118, rotation: 0, imageRotation: 0 },
            { id: "4", x: 236, y: 58, width: 252, height: 367, rotation: 0, imageRotation: 0 },
            { id: "5", x: 495, y: 58, width: 134, height: 180, rotation: 0, imageRotation: 0 },
            { id: "6", x: 495, y: 245, width: 134, height: 180, rotation: 0, imageRotation: 0 },
            { id: "7", x: 855, y: 37, width: 317, height: 410, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-05",
        name: "LA 05 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h3_v4_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 235, y: 38, width: 206, height: 132, rotation: 0, imageRotation: 0 },
            { id: "2", x: 235, y: 177, width: 206, height: 132, rotation: 0, imageRotation: 0 },
            { id: "3", x: 235, y: 316, width: 206, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 856, y: 38, width: 155, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 856, y: 246, width: 155, height: 201, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 38, width: 155, height: 201, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 246, width: 155, height: 201, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-06",
        name: "LA 06 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h3_v4_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 58, y: 40, width: 304, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 369, y: 40, width: 304, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 58, y: 233, width: 148, height: 211, rotation: 0, imageRotation: 0 },
            { id: "4", x: 213, y: 233, width: 148, height: 211, rotation: 0, imageRotation: 0 },
            { id: "5", x: 369, y: 233, width: 148, height: 211, rotation: 0, imageRotation: 0 },
            { id: "6", x: 524, y: 233, width: 148, height: 211, rotation: 0, imageRotation: 0 },
            { id: "7", x: 680, y: 40, width: 613, height: 404, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-07",
        name: "LA 07 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h3_v4_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 53, width: 285, height: 376, rotation: 0, imageRotation: 0 },
            { id: "2", x: 292, y: 53, width: 283, height: 376, rotation: 0, imageRotation: 0 },
            { id: "3", x: 583, y: 53, width: 285, height: 376, rotation: 0, imageRotation: 0 },
            { id: "4", x: 875, y: 53, width: 187, height: 121, rotation: 0, imageRotation: 0 },
            { id: "5", x: 875, y: 181, width: 187, height: 120, rotation: 0, imageRotation: 0 },
            { id: "6", x: 875, y: 309, width: 187, height: 120, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1069, y: 53, width: 283, height: 376, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-08",
        name: "LA 08 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h3_v4_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 59, y: 40, width: 613, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 680, y: 40, width: 304, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 991, y: 40, width: 303, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 680, y: 233, width: 148, height: 211, rotation: 0, imageRotation: 0 },
            { id: "5", x: 835, y: 233, width: 148, height: 211, rotation: 0, imageRotation: 0 },
            { id: "6", x: 991, y: 233, width: 148, height: 211, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1146, y: 233, width: 148, height: 211, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-09",
        name: "LA 09 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h3_v4_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 41, width: 280, height: 400, rotation: 0, imageRotation: 0 },
            { id: "2", x: 288, y: 41, width: 203, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 288, y: 178, width: 203, height: 128, rotation: 0, imageRotation: 0 },
            { id: "4", x: 288, y: 313, width: 203, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 498, y: 41, width: 280, height: 400, rotation: 0, imageRotation: 0 },
            { id: "6", x: 785, y: 41, width: 279, height: 400, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1072, y: 41, width: 279, height: 400, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-10",
        name: "LA 10 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h3_v4_10.png",
        size: [1352, 483],
        style: {},
        slots: [       
            { id: "1", x: 0, y: 41, width: 280, height: 400, rotation: 0, imageRotation: 0 },
            { id: "2", x: 288, y: 41, width: 279, height: 400, rotation: 0, imageRotation: 0 },
            { id: "3", x: 575, y: 41, width: 279, height: 400, rotation: 0, imageRotation: 0 },
            { id: "4", x: 862, y: 41, width: 279, height: 400, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1148, y: 41, width: 203, height: 129, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1148, y: 178, width: 203, height: 128, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1148, y: 313, width: 203, height: 128, rotation: 0, imageRotation: 0 }
        ],
    }
];